// start bf-af-slider
const containernamebfaf = document.querySelector('.container-first');
    document.querySelector('.slider').addEventListener('input', (e) => {
      containernamebfaf.style.setProperty('--position', `${e.target.value}%`);
    })
// end bf-af-slider



  // Add JavaScript to toggle between images based on screen size
  function toggleImages() {
    var desktopImg = document.querySelector('.desktop-img');
    var mobileImg = document.querySelector('.mobile-img');

    if (window.innerWidth < 768) {
      desktopImg.style.display = 'none';
      mobileImg.style.display = 'block';
    } else {
      desktopImg.style.display = 'block';
      mobileImg.style.display = 'none';
    }
  }

  // Initial call to set the correct image on page load
  toggleImages();

  // Add event listener to handle window resize
  window.addEventListener('resize', toggleImages);

// // FAQ's javascript code
//   // Select all FAQ items
//  document.querySelectorAll('.faq-item').forEach((item) => {
//    const icon = item.querySelector('.icon');
//    const answer = item.querySelector('.faq-answer');

//    // Initially hide all answers
//    answer.style.display = 'none';

//    // Toggle answer visibility and icon on click
//    item.querySelector('.faq-question').addEventListener('click', function () {
//      const isVisible = answer.style.display === 'block';
//      answer.style.display = isVisible ? 'none' : 'block';
//      icon.textContent = isVisible ? '+' : '-';
//    });
//  });


